import React from 'react';
import { CheckCircle2, Lock, FileCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function TrustSection() {
  const whatsappUrl = 'https://wa.me/2250700592164';
  const trustPoints = [{
    icon: CheckCircle2,
    text: 'Partenaire Visa'
  }, {
    icon: Lock,
    text: 'Chiffrement SSL 256-bit'
  }, {
    icon: FileCheck,
    text: 'Conforme aux réglementations BCEAO'
  }];
  return <section id="trust" className="py-20 bg-muted/50" data-id="element-126">
      <div className="container mx-auto px-4 md:px-6" data-id="element-127">
        <div className="bg-card rounded-2xl border border-border shadow-lg overflow-hidden" data-id="element-128">
          <div className="p-8 md:p-12 lg:p-16 text-center" data-id="element-129">
            <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl mb-8" data-id="element-130">
              Vos paiements en toute confiance
            </h2>

            <div className="flex flex-wrap justify-center gap-8 mb-12" data-id="element-131">
              {trustPoints.map((point, index) => <div key={index} className="flex items-center gap-3 bg-background px-6 py-3 rounded-full border border-border shadow-sm" data-id="element-132">
                  <point.icon className="h-5 w-5 text-green-600" data-id="element-133" />
                  <span className="font-medium text-foreground" data-id="element-134">
                    {point.text}
                  </span>
                </div>)}
            </div>

            <div className="max-w-2xl mx-auto space-y-8" data-id="element-135">
              <p className="text-lg text-muted-foreground" data-id="element-136">
                Nous comprenons l'importance de la sécurité pour votre
                entreprise. C'est pourquoi nous utilisons les standards de
                sécurité les plus élevés de l'industrie.
              </p>

              <Button size="lg" className="w-full sm:w-auto text-base px-8 h-12" onClick={() => window.open(whatsappUrl, '_blank')} data-id="element-137">
                Rejoignez des centaines d'importateurs qui font confiance à
                CafaPay
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}